import { Popover } from 'mag-react-components';

export default function UglyLegend() {
  const legendItems = [
    {
      label: 'Area with an 60%+ majority of households below 80% AMI ($63,500)',
      symbol: function () {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23">
            <defs></defs>
            <g transform="matrix(1.1201298236846924,0,0,1.1201298236846924,11.5,11.5)">
              <path
                fill="rgba(255, 198, 39)"
                fillRule="evenodd"
                stroke="rgba(0, 0, 0, 1)"
                strokeWidth="0.5333333333333333"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="none"
                strokeMiterlimit="4"
                d="M -10,-10 L 10,0 L 10,10 L -10,10 L -10,-10 Z"
              ></path>
            </g>
          </svg>
        );
      },
    },
    {
      label: 'Area with an 60%+ majority of households below 50% AMI ($39,500)',
      symbol: function () {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23">
            <defs></defs>
            <g transform="matrix(1.1201298236846924,0,0,1.1201298236846924,11.5,11.5)">
              <path
                fill="rgba(168, 56, 0, 1)"
                fillRule="evenodd"
                stroke="rgba(0, 0, 0, 1)"
                strokeWidth="0.5333333333333333"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="none"
                strokeMiterlimit="4"
                d="M -10,-10 L 10,0 L 10,10 L -10,10 L -10,-10 Z"
              ></path>
            </g>
          </svg>
        );
      },
    },
    {
      label: 'No Data Available',
      symbol: function () {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23">
            <defs></defs>
            <g transform="matrix(1.1201298236846924,0,0,1.1201298236846924,11.5,11.5)">
              <path
                fill="rgba(128, 128, 128, .7)"
                fillRule="evenodd"
                stroke="rgba(0, 0, 0, 1)"
                strokeWidth="0.5333333333333333"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="none"
                strokeMiterlimit="4"
                d="M -10,-10 L 10,0 L 10,10 L -10,10 L -10,-10 Z"
              ></path>
            </g>
          </svg>
        );
      },
    },
  ];

  return (
    <div>
      <div
        style={{ marginLeft: '0px' }}
        className="esri-component esri-legend esri-widget esri-widget--panel"
      >
        <div className="esri-legend__service" tabIndex="0">
          <div style={{ float: 'right', marginBottom: '-20px' }}>
            <Popover
              title="AMI Help"
              definition="The 80% Area Median Income (AMI) used for this analysis is the 4 person annual value calculated for FY2021."
            />
          </div>
          <div className="esri-legend__layer">
            <div className="esri-legend__layer-table esri-legend__layer-table--size-ramp">
              <div className="esri-legend__layer-caption"></div>
              <div className="esri-legend__layer-body">
                {legendItems.map(({ label, symbol, subLabel }, index) => (
                  <div key={index} className="esri-legend__layer-row">
                    <div className="esri-legend__layer-cell esri-legend__layer-cell--symbols">
                      <div className="esri-legend__symbol">
                        <div style={{ opacity: 1 }}>{symbol()}</div>
                      </div>
                    </div>
                    <div className="esri-legend__layer-cell esri-legend__layer-cell--info">
                      {label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
